/**
 * Canonical Resources nav order (header + footer). Icons live in the header client component.
 */
export const MARKETING_RESOURCE_NAV_ITEMS = [
  {
    href: "/guides",
    name: "Guides",
    description: "Step-by-step setup for new projects",
  },
  {
    href: "/methodology",
    name: "Methodology",
    description: "Frameworks and canonical methods",
  },
  {
    href: "/case-studies",
    name: "Case Studies",
    description: "Client work and outcomes",
  },
  {
    href: "/research",
    name: "Research",
    description: "Data and flagship reports",
  },
  {
    href: "/blog",
    name: "Blog",
    description: "Articles and insights",
  },
  {
    href: "/engineering",
    name: "Engineering",
    description: "How we build Ripenn",
  },
] as const;

export type MarketingResourceNavItem =
  (typeof MARKETING_RESOURCE_NAV_ITEMS)[number];
